export const AUTOPILOT_NAME = "Otto";

export const AUTOPILOT_AVATAR_URL =
  "/autogpt-characters/v1.1/otto/neutral/128.webp";

export const AUTOPILOT_TRANSPARENT_AVATAR_URL =
  "/experts/transparent/otto.webp";

export const AUTOPILOT_AVATAR_BG_CLASS = "bg-accent-surface";

export const AUTOPILOT_COVER_URL = "/experts/covers/otto-cover-3.png";

/** Light and mid lavender, for effects drawn around Otto — the voice aura's
 *  comets and the dots that collapse into him. */
export const AUTOPILOT_AURA_COLORS: [string, string] = ["#ddd6fe", "#a78bfa"];

export const AUTOPILOT_DOT_COLOR = "#a78bfa";
